module.exports = __webpack_public_path__ + "static/media/donate_covid_300x300.9cd8d85d.jpg";